/**
 * Reine Fähigkeitsprüfung für die lokale Spracherkennung.
 *
 * Gibt immer false zurück – alle Mikrofon-Eingaben gehen über Groq Whisper
 * (server-seitig). Lokale ONNX-Inferenz war ~250 MB Download, crashte
 * WKWebView auf iOS zuverlässig und ist auf dem Server ohnehin schneller.
 */
export function localTranscribeSupported(): boolean {
  return false;
}
